import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { PersonFormService } from './person.form.service';
import { FormControl, FormGroup, FormArray, ValidatorFn, AbstractControl } from '@angular/forms';
import { Globals } from '../../globals';
import { AppService } from '../../app.service';
import { Formvalidator } from './person.form.formvalidator';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { Countries } from '../../shared/countries/countries';
import { ActivatedRoute } from '@angular/router'; 
import { NgxSmartModalService } from 'ngx-smart-modal';
import { formatDate } from '@angular/common';
import translateJson from "../../../translate.json";
import customerJson from "../../../assets/config/customer.json";

import { DateAdapter, MatDatepicker } from '@angular/material';
import { ValidationModalComponent } from '../../shared/views/ValidationModalComponent/validation.modal.component';
import { DepartmentTreeComponent } from '../../shared/views/DepartmentTreeComponent/department.tree.component';
import { ErrorModalComponent } from '../../shared/views/ErrorModalComponent/error.modal.component'

import { DateUpdateFix } from '../../models/date-update-fix';
import { AuthenticationService } from '../../auth';

enum otherTypeEnum {Employer, FAS, Groups};
enum addressType {NATIONAL, INTERNATIONAL, FELLOWAPPLICANT, DEPARTMENT, GOVERNMENT, SECURITYACTIVITYDATES};

@Component({
  selector: 'person-comp',
  providers: [PersonFormService,  AppService, Formvalidator, ConfirmService, Countries, DateUpdateFix, MatDatepicker, AuthenticationService], 
  templateUrl: './person.form.component.html',  
  styleUrls: ['../person.component.css']  
})

export class PersonFormComponent {    

  @ViewChild('validationModal') validationModal: ValidationModalComponent;
  @ViewChild('treeComponent') treeComponent: DepartmentTreeComponent;
  @ViewChild('errorModalComponent') errorModalComponent: ErrorModalComponent;

  // Get translation/text from customerJson
  private i18 = translateJson.i18;
  private customerOrgId: String = customerJson.customer.organisationId;
  private customerCountryCode: String = customerJson.customer.countryCode;
  private customerName: String = customerJson.customer.name;
  private globalOrgAssociations = customerJson.settings.globalOrgAssociations;
  private showGenderField: Boolean = customerJson.settings.showGenderField;
  private rolesAndPermissions: Boolean = false;
  private notSpecified: String = "";
  private person: any;
  private previousType: String;
  
  employers: any = []; // All employers
  subcontractorEmployers: any = []
  customerEmployer: any = {}

  projects: any = [];
  fasArray: any = [];
  otherType: String = otherTypeEnum[0];
  showLoader: Boolean = false;
  column: String;
  fasAvailable: Boolean = false;
  isDesc: Boolean; 
  filteredEmployer: String; 
  filteredProject: String; 
  filteredGroup: String; 

  noSsn: Boolean = true;
  noCoordinationNumber: Boolean = true;
  doesSsnAlreadyExist: Boolean = false;
  doesCordNumAlreadyExist: Boolean = false;
  disableSaveButton: Boolean = false; 

  fellowApplicantForm: FormGroup;
  addressForm: FormGroup;
  addressIntForm: FormGroup;
  personForm: FormGroup;
  govPersonForm: FormGroup;
  nationality: FormControl;

  id: String;
  type: String;
  departmentId: String;
  ready: Boolean = false;
  
  ministryArray: any = [];
  entityArray: any = [];
  sectionArray: any = [];

  // Used to display messages on adding/removing org associations to/from the person.
  alertAddedAssociation: boolean = false;
  alertDeletedAssociation: boolean = false;
  alertUpdatedAssociation: boolean = false;
  lastOrgAssociationDeleted: boolean = false;
  rkOrgAssociation: any;  
  selectedOrgAssociation: any;
  selectedOrgAssociationIndex: number;
  numOfNotes:number = 0;
  groupList: any = [];
  personGroupList: any = []; 
  selectedCountryList: any = [];
  doesFaSsnAlreadyExist: boolean = false;
  faSsnSamePerson: boolean = false; 
  doesFaCoordinationNumberAlreadyExist: boolean = false;
  faCoordinationNumberSamePerson: boolean = false; 
  readyToAddFellow: boolean = false;

  /**
   * Constructor
   * @param service         Service for this view
   * @param appService      General service for whole app
   * @param formValidator   Validation class
   * @param confirmService  Service for confirm-modal
   * @param activatedRoute  Route for the URL
   * @param location        To be able to go back to previous view
   * @param countries       List of all countries and their countrycodes
   */
  constructor(
    private service: PersonFormService,
    private appService: AppService,
    private formValidator: Formvalidator,     
    private confirmService: ConfirmService,
    private ngxSmartModalService: NgxSmartModalService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private countries: Countries,
    private dateAdapter: DateAdapter<Date>,
    private dateUpdateFix: DateUpdateFix,
    private globals: Globals,
    private authService: AuthenticationService) {
      this.authService.isAuthenticated();
      this.id = this.activatedRoute.snapshot.paramMap.get('id');
      this.type = this.activatedRoute.snapshot.paramMap.get('type');
      this.fasAvailable = appService.isComponentActive('securityAgreement');
      this.rolesAndPermissions = this.globals.rolesAndPermissions;
      this.notSpecified = this.i18.orgAssociation.notSpecified;
      
      if(this.id != null && this.type === 'edit') {
        this.editPerson(this.id);
      } else if (this.id === null && this.type === 'new') {
        this.addPerson();
        if(this.rolesAndPermissions){
          this.setOtherType(2)
        }
      }
  }

  /**
   * Initiate all fields and prepare forms
   */
  setDefault() {
    this.dateAdapter.setLocale('sv');
    this.noSsn = true;
    this.noCoordinationNumber = true;
    this.disableSaveButton = false;

    this.nationality = new FormControl;

    this.addressForm = new FormGroup({
      id: new FormControl(),
      address_1: new FormControl(),
      address_2: new FormControl(),
      postCode: new FormControl(),
      city: new FormControl(),
      countryCode: new FormControl(),
      addressType: new FormControl()
    });  

    this.addressForm.patchValue({
      countryCode: 'SE', // Default value on hidden field
      addressType: addressType[0]
    });
    
    this.addressIntForm = new FormGroup({
      id: new FormControl(),
      address_1: new FormControl(),
      address_2: new FormControl(),
      postCode: new FormControl(),
      city: new FormControl(),
      countryCode: new FormControl(),
      addressType: new FormControl()
    });  

    this.addressIntForm.patchValue({     
      addressType: addressType[1]
    });    
    this.personForm = new FormGroup({
      generateSequenceNumber: new FormControl(false),
      personDiaryUid: new FormControl(),
      id: new FormControl(),
      ssn: new FormControl(),
      coordinationNumber: new FormControl(),
      noSsn: new FormControl(),
      noCoordinationNumber: new FormControl(),
      ssn_old: new FormControl(),
      firstName: new FormControl(),
      middleName: new FormControl(),
      lastName: new FormControl(),
      internalUserName: new FormControl(),
      gender: new FormControl(),
      employmentNumber: new FormControl(),
      nationalityCode: new FormControl(),
      personPhoneNumber: new FormControl(),
      //personTitle: new FormControl(),
      passportNumber: new FormControl(),
      employedByCustomer: new FormControl(true),
      securityActivityDateOne: new FormControl(),
      securityActivityDateTwo: new FormControl(),
      securityActivityDateThree: new FormControl(),
      securityActivityDateFour: new FormControl(),
      securityActivityDateFive: new FormControl(),
      securityActivityDateSix: new FormControl(),
      personEmail: new FormControl(),
      birthDate: new FormControl()
    });
    
    this.fellowApplicantForm = new FormGroup({
      id: new FormControl(),
      ssn: new FormControl(),
      coordinationNumber: new FormControl(),
      birthDate: new FormControl(),
      notSwedish: new FormControl(false),
      firstName: new FormControl(),
      lastName: new FormControl(),
      selectedFellowApplicant: new FormControl(),
      'fellowApplicants': new FormArray([])
    });
    
    this.govPersonForm = new FormGroup({
      selectedMinistry: new FormControl(null, [this.fieldsNotNull(), this.fieldSpecified()]),
      selectedEntity: new FormControl({value:"", disabled: true}),
      selectedSection: new FormControl({value:"", disabled: true}),
      selectedOrgAssociation: new FormControl()
    });    

    this.service.getAllDepartments().subscribe(
      data => this.patchDepartments(data),
      error => this.showError(error.error)
    );

    this.rkOrgAssociation = {
      "id": null,
      "delete": false,
      "update": false,
      "isChecked": false
    };
  }

  /**
   * Custom validator that disallows null fields.
   */
  fieldsNotNull(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      return control.value !== null ? null : { errorMessage: this.i18.orgAssociation.emptyOrNotSpecifiedField}
    }
  }

  /**
   * Custom validator that checks if the field has been specified.
   */
  fieldSpecified(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
      control.value !== this.notSpecified ? null : { errorMessage: this.i18.orgAssociation.saveBelongingMsg }
  }

  /**
   * Disable SSN input
   */
  ssnDisabler(){
    if(this.noSsn) {
      this.noSsn = false;
      this.personForm.get('ssn').disable();
      this.personForm.get('gender').enable();
      this.personForm.patchValue({ssn: ''})
      this.personForm.patchValue({noSsn: true});
    } else {
      this.noSsn = true;
      this.personForm.get('ssn').enable();      
      this.personForm.patchValue({noSsn: false});
    }
  }

  /**
   * Disable SSN input
   */
  coordinationNumberDisabler(){
    if(this.noCoordinationNumber) {
      this.noCoordinationNumber = false;
      this.personForm.get('coordinationNumber').disable();
      this.personForm.get('gender').enable();
      this.personForm.patchValue({coordinationNumber: ''})
      this.personForm.patchValue({noCoordinationNumber: true});
    } else {
      this.noCoordinationNumber = true;
      this.personForm.get('coordinationNumber').enable();      
      this.personForm.patchValue({noCoordinationNumber: false});
    }
  }

  /**
   * Patch MAT-Select array to nationalityCode in personform
   * @param e Event from mat-select 
   */
  nationalityHandler(e:any) {       
    let sel = [], tmpsel = [], unsel = []
    
    this.countries.countries.forEach(item=> { 
      if (e.value.indexOf(item.code2) !== -1) {
        tmpsel.push(item);
      } else {
        unsel.push(item);
      }       
    })   

    for(var i=0; i<e.value.length; i++) {      
      tmpsel.forEach(item => {        
        if (e.value[i].indexOf(item.code2) !== -1) {
          sel.push(item);          
        }
      })
    }

    this.countries.countries = [ ...sel, ...unsel ];  
   
    let countryCodesStr = "";    
    for(let code of sel) {
      countryCodesStr += code.code2 +',';      
    }
    countryCodesStr = countryCodesStr.slice(0, -1);  
    // Country code string store to db cant be bigger than 255 in length
    if (countryCodesStr.length > 255) {
      countryCodesStr = countryCodesStr.slice(0, -3);
    }
    this.personForm.patchValue({nationalityCode: countryCodesStr});     
  }  
 

  /**
   * Disable faSSN input
   */
  faSsnDisabler() {
    this.formValidator.validateFASsn(this.fellowApplicantForm.value, this.validationModal.getModalArray());
  }

  /**
   * Set the URL-route to the specified route
   * @param route Route to change to
   */
  setRoute(route) {
    this.appService.setRoute(route);
  }
  
  /**
   * Go back to the previous view from where we came
   */
  back() {
    this.confirmService.confirm(this.i18.organisation.form.confirmNoSave)
      .then(result => {
        if(result) {
          this.location.back();
        }
      });
  }

  /**
   * Prepare view for adding a person
   */
  addPerson() {
    this.setDefault();
    this.person = {};
    this.person.addresses = [{'addressType': addressType[0]}, {'addressType': addressType[1]}, {'addressType': addressType[2]}];    
    this.person.employers = [];
    this.person.orgAssociations = [];
    if(this.fasAvailable) {
      this.person.securityAgreements = [];
    }
    this.person.departments = [];
    this.person.projects = [];
    this.person.addressTypeView = addressType[0];
    this.getEmployers();
    this.getOwnerGroups();
    if(this.fasAvailable) { this.getFasProjects(); }
    this.selectedCountryList.push('SE');
    this.nationalityHandler({value: this.selectedCountryList});    
    this.nationality.setValue(this.selectedCountryList);    
    this.ready = true;
  }

  /**
   * Prepare view for editing a existing person
   * @param id person unique id
   */
  editPerson(id) {
    this.service.getPersonById(id)      
      .subscribe(
        data => this.displayPerson(data),
        error =>  this.showError(error.error),  
        () => this.showLoader = false      
      );
  }

  /**
   * Display a selected person
   * @param person person object
   */
  displayPerson(person) {
    this.setDefault();

    this.person = person;
    this.person.coordinationNumber = person.coordinationNumber;
    this.person.departments = person.departments;
    this.person.showPersonDetails = true;
    this.person.showOtherDetails = true;
    this.person.showNotesDetails = true;
    this.person.showFellowApplicantDetails = false;
    this.person.showDateDetails = true;
    this.person.showRegisterDetails = true;  
    this.person.showNoteEditor = false;
    this.person.addressTypeView = addressType[0];
    if(this.person.birthDate != null) {
      this.personForm.patchValue({
        birthDate: this.person.birthDate
      })
    }

    this.service.getAllDepartments().subscribe(
      data => this.patchDepartments(data),
      error => this.showError(error.error)
    );

    this.setPersonAndAddresses();
    this.getEmployersByPersonId(this.person.id);
    // set the number of notes on first load. this will then be updated when a user adds/removes notes
    this.numOfNotes = this.person.notes.length;
    if(this.rolesAndPermissions){
      this.getOwnerGroups();
      if(this.isEmployedByCustomer(this.person)){
        this.setOtherType(2)
      }
    }
    
    this.ready = true;
  }

  /**
   * Toggle the generate diary functionality
   */
  customDiaryDisabler() {
    if (this.personForm.value.generateSequenceNumber) {
        this.personForm.get('personDiaryUid').disable();
        this.personForm.patchValue({personDiaryUid: this.i18.person.form.generatingNumber});

    } else {
        this.personForm.get('personDiaryUid').enable();
        this.personForm.patchValue({personDiaryUid: null});
    }
  }

  /**
   * Insert data into forms
   */
  setPersonAndAddresses() {
    this.personForm.patchValue({
      personDiaryUid: this.person.personDiaryUid,
      id: this.person.id,
      ssn: this.person.ssn,
      coordinationNumber: this.person.coordinationNumber,
      noSsn: this.person.noSsn,
      noCoordinationNumber: this.person.noCoordinationNumber,
      ssn_old: this.person.ssn,
      firstName: this.person.firstName,
      middleName: this.person.middleName,
      lastName: this.person.lastName,
      internalUserName: this.person.internalUserName,
      employmentNumber: this.person.employmentNumber,
      gender: this.person.gender,
      nationalityCode: this.person.nationalityCode,
      //personTitle: this.person.personTitle,
      personEmail: this.person.personEmail,
      personPhoneNumber: this.person.personPhoneNumber,
      passportNumber: this.person.passportNumber,
      employedByCustomer: this.isEmployedByCustomer(this.person),
      securityActivityDateOne: (this.person.securityActivityDateOne === null ? null : formatDate(this.person.securityActivityDateOne, 'yyyy-MM-dd', 'en')),
      securityActivityDateTwo: (this.person.securityActivityDateTwo === null ? null : formatDate(this.person.securityActivityDateTwo, 'yyyy-MM-dd', 'en')),
      securityActivityDateThree: (this.person.securityActivityDateThree === null ? null : formatDate(this.person.securityActivityDateThree, 'yyyy-MM-dd', 'en')),
      securityActivityDateFour: (this.person.securityActivityDateFour === null ? null : formatDate(this.person.securityActivityDateFour, 'yyyy-MM-dd', 'en')),
      securityActivityDateFive: (this.person.securityActivityDateFive === null ? null : formatDate(this.person.securityActivityDateFive, 'yyyy-MM-dd', 'en')),
      securityActivityDateSix: (this.person.securityActivityDateSix === null ? null : formatDate(this.person.securityActivityDateSix, 'yyyy-MM-dd', 'en'))
    });

    // if missing then type when editing 
    if (this.person.addresses.length < 1) {
      this.person.addresses.push({'addressType': addressType[0]});
    }
    if (this.person.addresses.length < 2) {
      this.person.addresses.push({'addressType': addressType[1]});
    }

    for(let i = 0; i < this.person.addresses.length; i++) {      
      if (this.person.addresses[i].addressType == addressType[0]) {
        this.addressForm.patchValue({
          id: this.person.addresses[i].id,
          address_1: this.person.addresses[i].address_1,
          address_2: this.person.addresses[i].address_2,
          postCode: this.person.addresses[i].postCode,
          city: this.person.addresses[i].city,
          countryCode: this.person.addresses[i].countryCode
        })
      } else if (this.person.addresses[i].addressType == addressType[1]) {
        this.addressIntForm.patchValue({
          id: this.person.addresses[i].id,
          address_1: this.person.addresses[i].address_1,
          address_2: this.person.addresses[i].address_2,
          postCode: this.person.addresses[i].postCode,
          city: this.person.addresses[i].city,
          countryCode: this.person.addresses[i].countryCode
        });
      }
    }

    if(this.person.noSsn) {
      this.ssnDisabler();
    }
    if(this.person.noCoordinationNumber) {
      this.coordinationNumberDisabler();
    }

    for(let i = 0; i < this.person.fellowApplicants.length; i++) {

      let tempFA = this.person.fellowApplicants[i];

      (<FormArray>this.fellowApplicantForm.get('fellowApplicants')).push(new FormGroup({
        id: new FormControl(tempFA.id),
        ssn: new FormControl(tempFA.ssn),
        coordinationNumber: new FormControl(tempFA.coordinationNumber),
        birthDate: new FormControl(tempFA.birthDate),
        notSwedish: new FormControl(tempFA.notSwedish),
        firstName: new FormControl(tempFA.firstName),
        lastName: new FormControl(tempFA.lastName)
      }));
    }

    // Set values in MAT-select nationality
    let countryCodes = this.person.nationalityCode.split(',');    
    for(let countryCode of countryCodes) {
      this.selectedCountryList.push(countryCode);         
    }
   
    this.nationalityHandler({value: this.selectedCountryList});    
    this.nationality.setValue(this.selectedCountryList);    
  }  

  /**
   * Set tab view for address
   * @param type type of address
   */
  setAddressTypeView(type) {
    this.person.addressTypeView = addressType[type];
    if(this.previousType==='DEPARTMENT') {
      this.departmentId = this.treeComponent.getDepartmentId();
    }
    this.previousType = addressType[type];
  }

  /**
   * Confirm that form for internationl country shall be cleared
   */
  removeInternationalAddress() {
    this.confirmService.confirm(this.i18.modals.confirmModal.countryRemovalInformation)
      .then(result => {
        if (result) {
          this.addressIntForm = new FormGroup({
            id: new FormControl(),
            address_1: new FormControl(),
            address_2: new FormControl(),
            postCode: new FormControl(),
            city: new FormControl(),
            countryCode: new FormControl(),
            addressType: new FormControl()
          });  
        }
      });     
  }

  /**
   * Save new person information
   * @param personForm data from person form
   * @param addressForm data from address form
   * @param addressIntForm data from international form
   * @param fellowApplicantForm fata from fellowApplicantForm
   */
  savePerson(personForm, addressForm, addressIntForm, fellowApplicantForm) {
    let person = personForm;
    person.noSsn = !this.noSsn;
    person.noCoordinationNumber = false;
    this.setAddressTypeView(0);
    this.showLoader = true;
    person.gender = this.personForm.getRawValue().gender;
    person.employers = this.person.employers;
    if(this.fasAvailable) {
      person.securityAgreements = this.person.securityAgreements;
    }
    person.departments = this.person.departments;
    person.projects = this.person.projects;

    person.addresses = [];
    person.addresses.push(addressForm);

    if (addressIntForm.countryCode != null) {
      person.addresses.push(addressIntForm);
    }
    if(this.personForm.value.employedByCustomer || this.globalOrgAssociations) {
      person.orgAssociations = this.person.orgAssociations;
    }
    person.fellowApplicants = fellowApplicantForm.fellowApplicants;

    person.securityActivityDateOne = this.dateUpdateFix.fixDateOnUpdate(this.personForm.get('securityActivityDateOne').value);
    person.securityActivityDateTwo = this.dateUpdateFix.fixDateOnUpdate(this.personForm.get('securityActivityDateTwo').value);
    person.securityActivityDateThree = this.dateUpdateFix.fixDateOnUpdate(this.personForm.get('securityActivityDateThree').value);
    person.securityActivityDateFour = this.dateUpdateFix.fixDateOnUpdate(this.personForm.get('securityActivityDateFour').value);
    person.securityActivityDateFive = this.dateUpdateFix.fixDateOnUpdate(this.personForm.get('securityActivityDateFive').value);
    person.securityActivityDateSix = this.dateUpdateFix.fixDateOnUpdate(this.personForm.get('securityActivityDateSix').value);

    this.service.savePerson(person, this.personGroupList)
    .subscribe(
      data => this.setRoute('person/view/' + data.id),
      error => {
        this.showError(error);            
      },
      () => this.showLoader = false 
    );
     
  }

  /**
   * Update existing person information
   * @param personForm data from person form
   * @param addressForm data from address form
   * @param addressIntForm data from international form
   * @param fellowApplicantForm fata from fellowApplicantForm
   */
  updatePerson(personForm, addressForm, addressIntForm, fellowApplicantForm) {
    this.setAddressTypeView(0);    
    this.showLoader = true;
    let person = personForm;
    person.gender = this.personForm.getRawValue().gender;
    person.employers = this.person.employers;
    person.projects = this.person.projects;
    if(this.fasAvailable) {
      person.securityAgreements = this.person.securityAgreements;
    }
    person.noSsn = !this.noSsn;
    person.noCoordinationNumber = !this.noCoordinationNumber;
    person.addresses = [];
    person.addresses.push(addressForm);

    if (addressIntForm.countryCode != null) {
      person.addresses.push(addressIntForm);
    }

    if (person.employers != null ) {
      for(let i =0; i < person.employers.length; i++) {
        person.employers[i].projectList = null;
        person.employers[i].notes = null;
      }
    }
    
    /*for(let i =0; i < person.notes.length; i++) {
      person.notes[i].createdDate = null;
    }*/
    
    if(this.personForm.value.employedByCustomer || this.globalOrgAssociations){
      person.orgAssociations = this.person.orgAssociations;
    }
    
    person.fellowApplicants = fellowApplicantForm.fellowApplicants;

    /*
    Hot fix to save activity dates correctly when updating a person.
    */

    person.securityActivityDateOne = ((personForm.securityActivityDateOne === null || personForm.securityActivityDateOne === "") ? null : this.dateUpdateFix.fixDateOnUpdate(personForm.securityActivityDateOne));
    person.securityActivityDateTwo = ((personForm.securityActivityDateTwo === null || personForm.securityActivityDateTwo === "") ? null : this.dateUpdateFix.fixDateOnUpdate(personForm.securityActivityDateTwo));
    person.securityActivityDateThree = ((personForm.securityActivityDateThree === null || personForm.securityActivityDateThree === "") ? null : this.dateUpdateFix.fixDateOnUpdate(personForm.securityActivityDateThree));
    person.securityActivityDateFour = ((personForm.securityActivityDateFour === null || personForm.securityActivityDateFour === "") ? null : this.dateUpdateFix.fixDateOnUpdate(personForm.securityActivityDateFour));
    person.securityActivityDateFive = ((personForm.securityActivityDateFive === null || personForm.securityActivityDateFive === "") ? null : this.dateUpdateFix.fixDateOnUpdate(personForm.securityActivityDateFive));
    person.securityActivityDateSix = ((personForm.securityActivityDateSix === null || personForm.securityActivityDateSix === "") ? null : this.dateUpdateFix.fixDateOnUpdate(personForm.securityActivityDateSix));

    this.service.updatePerson(person, this.personGroupList, this.rkOrgAssociation)
    .subscribe(
      data => this.setRoute('person/view/' + data.id),
      error => this.showError(error),
      () => this.showLoader = false 
    );    
  }

  /**
   * Set other type
   * @param type type of page
   */
  setOtherType(type) {
    this.otherType = otherTypeEnum[type];
    if(this.otherType == 'Employer') {
      this.getEmployers();
    } else if (this.otherType == 'FAS') {
      this.getFasProjects();
    }
    else if (this.otherType == 'Groups'){
      // hämta lista för handläggarensgruppar 
    }
  }

  /**
   * Get all employers for a new person, and set customer as employer by default.
   */
  getEmployers() {
    this.service.getAllEmployers()
      .subscribe(
        data => {
          this.setupEmployers(data)
        },
        error => this.showError(error.error)       
      )
  }

  /**
   * Get all employers mapped to a person
   * @param personId Unique person identifier
   */
   getEmployersByPersonId(personId) {
    this.service.getAllEmployersByPersonId(personId)
      .subscribe(
        data => this.setupEmployers(data),
        error => this.showError(error.error)       
      )
  }

  /**
   * Set the person's employers as selected and store the different employers in variables.
   * @param employers An array of employers.
   */
  setupEmployers(employers: Array<any>) {
    // Mark the person's employers as selected
    for (const employer of employers) {
      for (const personEmployer of this.person.employers) {
        if (employer.id === personEmployer.id) {
          employer.selected = true;
          break;
        }
      }
    }

    this.employers = employers;
    this.subcontractorEmployers = employers/*.filter(employer => (employer.organisationId !== this.customerOrgId && employer.countryCode !== this.customerCountryCode) ||
        (employer.organisationId === this.customerOrgId && employer.countryCode !== this.customerCountryCode));*/
    this.customerEmployer = employers.find(employer => employer.organisationId === this.customerOrgId && employer.countryCode === this.customerCountryCode);
    if(this.type === 'new' && this.personForm.value.employedByCustomer == true) {
      this.person.employers = this.setEmployerToCustomer()
    }
  }

  /**
   * Function to build up the department object
   * @param departmentName name of the department
   * @param employer the employer object
   */
  setEmployerDepartment(departmentName, employer) {
    let object;
    let departmentId;
    for(let i = 0; i < employer.departments.length; i++) {
      if(employer.departments[i].departmentName == departmentName) {
        departmentId = employer.departments[i].id;
      }
    }
    object = {departmentId: departmentId, employerId: employer.id, departmentName: departmentName};
    for(let i = 0; i < this.person.departments.length; i++) {
      if(this.person.departments[i].employerId == object.employerId) {
        this.person.departments[i].departmentId = object.departmentId;
        this.person.departments[i].departmentName = object.departmentName;
        return;
      }
    }
    this.person.departments.push(object);
  }

  /**
   * Set selected employers
   * @param isSelected 
   * @param id 
   * @param employer
   */
  setSelectedEmployers(isSelected, id, employer) {
    let object = {id: id};

    if (!isSelected) {
      for (let i = 0; i <= this.person.employers.length; i++) {        
        if (this.person.employers[i].id == id) {
          this.person.employers.splice(i, 1);
          break;
        }
      }
    } else {
      this.person.employers.push(object);
    }    
  }
  
  /**
   * Get all projects
   */
  getFasProjects() {
    this.service.getAllFasProjects()
      .subscribe(
        data => this.filterSelectedFas(data),
        error => this.showError(error.error)
      )
  }

  /**
   * Set selected employers
   * @param isSelected 
   * @param id 
   * @param employer
   */
  setSecurityAgreement(isSelected, id, fas) {
    let object = {id: id};   
    if (!isSelected) {
      for (let i = 0; i <= this.person.securityAgreements.length; i++) {        
        if (this.person.securityAgreements[i].id == id) {
          this.person.securityAgreements.splice(i, 1);
          break;
        }
      }
    } else {
      this.person.securityAgreements.push(object);
    }    
  }

  /**
   * Filter security agreements that are already selected for a person
   * @param SecurityAgreements 
   */
  filterSelectedFas(fas) {
    for (let i = 0; i < fas.length; i++) {      
      for(let j = 0; j < this.person.securityAgreements.length; j++) {
        if (fas[i].id == this.person.securityAgreements[j].id) {
          fas[i].selected = true;
          fas[i].showDepartment = true;
          break;
        } 
      }      
    }
    this.fasArray = fas;
  }

  /**
   * Remove a fellowApplicant from the list
   * @param fellowApplicantIndex 
   */
  deleteFellowApplicant(fellowApplicantIndex) {
    let removeIndex:number = 0;
    if(fellowApplicantIndex == null) {
      removeIndex = 0;
    } else {
      removeIndex = ++fellowApplicantIndex;
    }

    let arrLength = (<FormArray>this.fellowApplicantForm.get('fellowApplicants')).length;
    if(arrLength == 1) {
      (<FormArray>this.fellowApplicantForm.get('fellowApplicants')).removeAt(0);
    } else {
      (<FormArray>this.fellowApplicantForm.get('fellowApplicants')).removeAt(removeIndex);
    }
  }

  /**
     * Adds a fellowApplicant to the list
     * @param inputName name of the department
     */
  addFellowApplicantToList(fellowApplicantForm) {
    if(!this.readyToAddFellow) {
      return;
    }

    let ssn = fellowApplicantForm.ssn;
    let coordinationNumber = fellowApplicantForm.coordinationNumber;
    let birthDate = fellowApplicantForm.birthDate;
    let notSwedish = fellowApplicantForm.notSwedish;
    let firstName = fellowApplicantForm.firstName;
    let lastName = fellowApplicantForm.lastName;

    (<FormArray>this.fellowApplicantForm.get('fellowApplicants')).push(new FormGroup({
      ssn: new FormControl(ssn),
      coordinationNumber: new FormControl(coordinationNumber),
      birthDate: new FormControl(birthDate),
      notSwedish: new FormControl(notSwedish),
      firstName: new FormControl(firstName),
      lastName: new FormControl(lastName)
    }));
      
    this.fellowApplicantForm.patchValue({
      id: null,
      ssn: null,
      coordinationNumber: null,
      birthDate: null, 
      notSwedish: false,
      firstName: null,
      lastName: null
    });

    this.readyToAddFellow = false;
    this.doesFaSsnAlreadyExist = false;
    this.doesFaCoordinationNumberAlreadyExist = false;
    this.faSsnSamePerson = false;
    this.faCoordinationNumberSamePerson = false; 
  }

  /**
   * Checks if the SSN exist on a fellow applicant in the list of applicants and that the fellow dont have the same ssn as the main person.
   * @param ssn A fellow applicant ssn.
   */
  fellowApplicantExistsBySSN(ssn: any) {
    let faInList = this.fellowApplicantForm.value.fellowApplicants.find((fa: any) => fa.ssn === ssn) ? true : false;
    if(!faInList && this.personForm.value.ssn != undefined && this.personForm.value.ssn != null && this.personForm.value.ssn != '' && this.personForm.value.ssn === ssn) {
      this.faSsnSamePerson = true;
      this.doesFaSsnAlreadyExist = false;
    } else if(!faInList && this.personForm.value.ssn != undefined && this.personForm.value.ssn != null && this.personForm.value.ssn != '') {
      this.faSsnSamePerson = false;
      this.doesFaSsnAlreadyExist = false;
    } else if (faInList) {
      this.faSsnSamePerson = false;
      this.doesFaSsnAlreadyExist = true;
    } else {
      this.faSsnSamePerson = false;
      this.doesFaSsnAlreadyExist = false;
    }
  }
  
  /**
   * Checks if the CoordinationNumber exist on a fellow applicant in the list of applicants and that the fellow dont have the same CoordinationNumber as the main person.
   * @param ssn A fellow applicant CoordinationNumber.
   */
  fellowApplicantExistsByCoordinationNumber(faCoordinationNumber: any) {
     let faInList = this.fellowApplicantForm.value.fellowApplicants.find((fa: any) => fa.coordinationNumber === faCoordinationNumber) ? true : false;
    if(!faInList && this.personForm.value.coordinationNumber != undefined && this.personForm.value.coordinationNumber != null && this.personForm.value.coordinationNumber != '' && this.personForm.value.coordinationNumber === faCoordinationNumber) {
      this.faCoordinationNumberSamePerson = true;
      this.doesFaCoordinationNumberAlreadyExist = false;
    } else if(!faInList && this.personForm.value.coordinationNumber != undefined && this.personForm.value.coordinationNumber != null && this.personForm.value.coordinationNumber != '') {
      this.faCoordinationNumberSamePerson = false;
      this.doesFaCoordinationNumberAlreadyExist = false;
    } else if(faInList){
      this.faCoordinationNumberSamePerson = false;
      this.doesFaCoordinationNumberAlreadyExist = true;
    } else {
      this.faCoordinationNumberSamePerson = false;
      this.doesFaCoordinationNumberAlreadyExist = false;
    }
  }

  /**
   * If all required fields are set enable the add fellow applicant button.
   */
  fellowReadyToAdd(){
    this.readyToAddFellow = false;
    let requiredFieldsPresent = false;
    let personIdenifier = false;
    
    if(this.fellowApplicantForm.value.ssn != undefined && this.fellowApplicantForm.value.ssn != null && this.fellowApplicantForm.value.ssn != '') {
      if(!this.faSsnSamePerson && !this.doesFaSsnAlreadyExist) {
        requiredFieldsPresent = true;
        personIdenifier = true;
      }
    } else if(this.fellowApplicantForm.value.coordinationNumber != undefined && this.fellowApplicantForm.value.coordinationNumber != null && this.fellowApplicantForm.value.coordinationNumber != '') {
      if(!this.faCoordinationNumberSamePerson && !this.doesFaCoordinationNumberAlreadyExist) {
        requiredFieldsPresent = true;
        personIdenifier = true;
      }
    } else if(this.fellowApplicantForm.value.birthDate != undefined && this.fellowApplicantForm.value.birthDate != null) {
      requiredFieldsPresent = true;
      personIdenifier = true;
    } else {
      personIdenifier = false;
    }

    if(personIdenifier && this.fellowApplicantForm.value.firstName != undefined && this.fellowApplicantForm.value.firstName != null && this.fellowApplicantForm.value.firstName != ''
        && this.fellowApplicantForm.value.lastName != undefined && this.fellowApplicantForm.value.lastName != null && this.fellowApplicantForm.value.lastName != '') {
          requiredFieldsPresent = true;
    } else {
      requiredFieldsPresent = false;
    }
    this.readyToAddFellow = requiredFieldsPresent;
  }

  /**
   * Show error
   * @param error error text
   */
  showError(error) { 
    this.confirmService.error(this.appService.getTranslatedErrorMessage(error));
    this.showLoader = false;
  }
  
  /**
   * Filter by employer name
   * @param event 
   */
  onFilterEmployer(event: any) {
    this.filteredEmployer = event.target.value;      
  } 

  /**
  * Filter by Group name
  * @param event 
  */
  onFilterGroup(event: any) {
      this.filteredGroup = event.target.value;      
  } 
  
  /**
   * Sort columns
   * @param property 
   * @param data 
   */
  sort(property, data){
    this.isDesc = !this.isDesc; //change the direction    
    this.column = property;
    let direction = this.isDesc ? 1 : -1;

    data.sort(function(a, b){
        if(a[property] < b[property]){
            return -1 * direction;
        }
        else if( a[property] > b[property]){
            return 1 * direction;
        }
        else{
            return 0;
        }
    });
  }
  
  /**
   * Function for automatically formatting the ssn if the user does not format correctly
   * @param ssn the ssn to format and patch into the form
   */
  ssnFix(ssn) {
    ssn = ssn.trim();
    if ((ssn.length === 10 || ssn.length === 12) &&ssn[ssn.length-5] != "-") {
      ssn = ssn.substring(0, ssn.length-4) + "-" + ssn.slice(ssn.length-4);
    }

    if (ssn.replace("-", "").trim().length === 10) {
      if (ssn.replace("-", "").trim()[0] < 3) {
        ssn = "20" + ssn;
      } else {
        ssn = "19" + ssn;
      }
    }

    let setGender = "";
    if (ssn.slice(ssn.length-2).toUpperCase() === "TF") {
      ssn = ssn.substring(0, ssn.length-2) + "TF";
      if(this.showGenderField){
        this.personForm.get('gender').enable();
      } else {
        this.personForm.patchValue({
          gender: 'MALE'
        });
      }

        // Validate if person already exists
        this.service.doesPersonBySsnExists(ssn)
          .subscribe(
            data => this.doesPersonAlreadyExist(data),
            () => this.showLoader = false
          );
    } else {
      let number = ssn.slice(ssn.length-2, -1);
      if (ssn.length > 10) {
        if (number % 2 === 1)
            setGender = 'MALE';
        else
            setGender = 'FEMALE';
        this.personForm.patchValue({
          gender: setGender
        });
        this.personForm.get('gender').disable();

        // Validate if person already exists
        this.service.doesPersonBySsnExists(ssn)
          .subscribe(
            data => this.doesPersonAlreadyExist(data),
            () => this.showLoader = false
          );
      } else {
        this.personForm.get('gender').enable();
      }
    }

    this.personForm.patchValue({
      ssn: ssn
    });
  }
  
  /**
   * Function for automatically formatting the ssn if the user does not format correctly
   * @param coordinationNumber the coordination number to format and patch into the form
   */
  coordinationNumberFix(coordinationNumber) {
    coordinationNumber = coordinationNumber.trim();
    if ((coordinationNumber.length === 10 || coordinationNumber.length === 12) && coordinationNumber[coordinationNumber.length-5] != "-") {
      coordinationNumber = coordinationNumber.substring(0, coordinationNumber.length-4) + "-" + coordinationNumber.slice(coordinationNumber.length-4);
    }

    if (coordinationNumber.replace("-", "").trim().length === 10) {
      if (coordinationNumber.replace("-", "").trim()[0] < 3) {
        coordinationNumber = "20" + coordinationNumber;
      } else {
        coordinationNumber = "19" + coordinationNumber;
      }
    }

    let setGender = "";
    if (coordinationNumber.slice(coordinationNumber.length-2).toUpperCase() === "TF") {
      coordinationNumber = coordinationNumber.substring(0, coordinationNumber.length-2) + "TF";
      if(this.showGenderField){
        this.personForm.get('gender').enable();
      } else {
        this.personForm.patchValue({
          gender: 'MALE'
        });
      }
    } else {
      let number = coordinationNumber.slice(coordinationNumber.length-2, -1);
      if (coordinationNumber.length > 10) {
        if (number % 2 === 1)
            setGender = 'MALE';
        else
            setGender = 'FEMALE';
        this.personForm.patchValue({
          gender: setGender
        });
        this.personForm.get('gender').disable();

        // Validate if person already exists
        this.service.doesPersonByCoordinationNumberExists(coordinationNumber)
          .subscribe(
            data => this.doesCoordinationNumberAlreadyExist(data),
            () => this.showLoader = false
          );
      } else {
        this.personForm.get('gender').enable();
      }
    }

    this.personForm.patchValue({
      coordinationNumber: coordinationNumber
    });
  }

  /**
   * Add form action when validating existing ssn //doesCordNumAlreadyExist
   * @param doesExist
   */
  doesPersonAlreadyExist(doesExist) {
    if(doesExist) {
      this.formValidator.formValidation.ssnError = true;
      this.doesSsnAlreadyExist = true;
    } else {
      this.formValidator.formValidation.ssnError = false;
      this.doesSsnAlreadyExist = false;
    }
  }

  /**
   * Add form action when validating existing ssn //doesCordNumAlreadyExist
   * @param doesExist
   */
  doesCoordinationNumberAlreadyExist(doesExist) {
    if(doesExist) {
      this.formValidator.formValidation.cordNumError = true;
      this.doesCordNumAlreadyExist = true;
    } else {
      this.formValidator.formValidation.cordNumError = false;
      this.doesCordNumAlreadyExist = false;
    }
  }
  

  /**
   * Sets the person's employer(s) and toggles the customer tab based on
   * the value of employedByCustomer in the personForm.
   */
  employedByCustomerChanged(): void {
    if (this.personForm.value.employedByCustomer != null && this.personForm.value.employedByCustomer == true) {
      this.setOtherType(2);
      this.service.getAllDepartments().subscribe(
        data => this.patchDepartments(data),
        error => this.showError(error.error)
      );
      this.person.employers = this.setEmployerToCustomer();
    } else if(this.personForm.value.employedByCustomer != null && this.personForm.value.employedByCustomer == false){
      this.setOtherType(0);
      this.person.employers = []
      for (const subEmployer of this.subcontractorEmployers) {
        if (subEmployer.selected) {
          this.person.employers.push({ id: subEmployer.id })
        }
      }
      this.setAddressTypeView(addressType.NATIONAL);
    }
    else {
      this.person.employers = null;
    }
  }


  /*
  * Patches prevoiusly stored government values from the database
  */
  setPersonGov(){
    if(this.person.govMinistry === null){
      
    } else {
      this.patchEntityArr(this.person.govMinistry);
      this.govPersonForm.patchValue({
        selectedMinistry: this.person.govMinistry
      });
      
      if(this.person.govEntity != null){
        this.patchSectionArr(this.person.govEntity);
        this.govPersonForm.patchValue({
          selectedEntity: this.person.govEntity
        });
      }
      
      if(this.person.govSection != null){
        this.govPersonForm.patchValue({
          selectedSection: this.person.govSection
        });
      }
    }
  }
  
  /**
     * populates the initial ministry array
     * @param data ministry data from backend
     */
  patchDepartments(data) {
      if(this.ministryArray.length > 0){
        this.ministryArray = [];
      }
      if(data.length > 0) {
        this.ministryArray.push(data)
      }
      if(this.person.govMinistry != null){
        this.setPersonGov();
      }
      
    }
    
    /**
     * Refreshes the entity array with data
     * @param ministryId id of the selected ministry
     */
    patchEntityArr(ministryName){
      if(ministryName === this.notSpecified){  
        this.enableInputs('ministry', this.notSpecified); 
      } else {
        this.entityArray = [];
        this.ministryArray[0].forEach(ministry => {
          if(ministry.ministryName === ministryName){
            if(ministry.govEntity.length > 0){
              this.entityArray.push(ministry.govEntity);
              this.enableInputs('ministry', true);
            } else {
              this.enableInputs('ministry', this.notSpecified);
            }
          }
        });
      }
    }
    
    /**
     * Refreshes the section array with data
     * @param entityId id of the selected entity
     */
    patchSectionArr(entityName){
      if(entityName === this.notSpecified){
        this.enableInputs('entity', this.notSpecified);
      } else {
        this.sectionArray = [];
        this.entityArray[0].forEach(entity => {
          if(entity.entityName === entityName){
            if(entity.govSection.length > 0){
              this.sectionArray.push(entity.govSection);
              this.enableInputs('entity', true);
              
            } else {
              this.enableInputs('entity', this.notSpecified);
            }
          }
        });
      }
    }
    
    /**
     * Enables/disables, resets the formcontrols and clears arrays depending on what change
     * event that occured
     * @param from from what change event the call came from.
     * @param value the value assosiated with the select option, a uuid or 0 for not valid selection
     */
    enableInputs(from, value){
      if(from === 'ministry' && value === this.notSpecified){
        this.entityArray = [];
        this.sectionArray = [];
        this.govPersonForm.get('selectedEntity').reset();
        this.govPersonForm.get('selectedEntity').disable();

        this.govPersonForm.get('selectedSection').disable();
        this.govPersonForm.get('selectedSection').reset();
      } else if (from === 'ministry' && value != this.notSpecified){
        this.govPersonForm.get('selectedEntity').enable();
        this.govPersonForm.get('selectedEntity').reset();
        if(this.entityArray.length === 0){
          this.enableInputs('ministry', this.notSpecified);
        }
        this.enableInputs('entity', this.notSpecified);
      }
      
      if(from === 'entity' && value === this.notSpecified){
        this.sectionArray = [];
        this.govPersonForm.get('selectedSection').disable();
        this.govPersonForm.get('selectedSection').reset();
      } else if (from === 'entity' && value != this.notSpecified){
        this.govPersonForm.get('selectedSection').enable();
        this.govPersonForm.get('selectedSection').reset();
        if(this.sectionArray.length === 0){
          this.enableInputs('entity', this.notSpecified);
        }
      }
    }

    /**
     * Takes the values of the govPersonForm to create and add a OrgAssociation
     * to the person's list of org associations.
     * @param govPersonForm A FormGroup
     */
    addOrgAssociation(govPersonForm: FormGroup): void {
      const values = govPersonForm.value

      const orgAssociation = {
        department: values.selectedMinistry,
        entity: values.selectedEntity || this.notSpecified,
        section: values.selectedSection || this.notSpecified
      }

      if (this.orgAssociationExists(orgAssociation)) {
        this.errorModalComponent.setErrorModalData([this.i18.modals.errorModal.errorHeader, this.i18.modals.errorModal.duplicationLabel, this.i18.modals.errorModal.orgAssociationError])
        this.errorModalComponent.pop()
      }
      else {
        this.person.orgAssociations.push(orgAssociation)
        this.govPersonForm.controls.selectedOrgAssociation.setValue(this.person.orgAssociations.length - 1)
        this.alertAddedAssociation = true;
        this.lastOrgAssociationDeleted = false;
      }
    }

    /**
     * Checks if the input orgAssociation already exist on the person by comparing
     * it with the department, entity and section of each stored orgAssociation.
     * @param orgAssociation An organisational association.
     */
    orgAssociationExists(orgAssociation: any): boolean {
      for (const association of this.person.orgAssociations) {
        if (orgAssociation.department === association.department
          && orgAssociation.entity === association.entity
          && orgAssociation.section === association.section) {
            return true;
          }
      }
      return false;
    }

    /**
     * Removes an orgAssociation from the person.
     * @param index Index of the org association to be removed.
     */
    deleteOrgAssociation(index) {
      this.person.orgAssociations.splice(index, 1);
      this.govPersonForm.controls.selectedOrgAssociation.setValue(null)
      this.alertDeletedAssociation = true;

      if (this.person.orgAssociations.length === 0) {
        this.alertAddedAssociation = false;
        this.lastOrgAssociationDeleted = true;
      }
    }

    /**
     * Checks if the person is employed by the customer or not.
     * @param person Person entity.
     */
    isEmployedByCustomer(person: any): boolean {
      return person.employers.length === 1 && person.employers[0].organisationId === this.customerOrgId && person.employers[0].countryCode === this.customerCountryCode;
    }

    /**
     * Returns an array containing a single object with the ID of the customer employer.
     */
    setEmployerToCustomer(): Array<any> {
      this.person.employers = [];
      return [{id: this.customerEmployer.id}]
    }

    /**
   * Function for automatically formatting the ssn of a fellow applicant if the user does not format correctly
   * @param ssn the ssn to format and patch into the form
   */
  fellowSSNFix(ssn) {
    if(!this.fellowApplicantForm.get('notSwedish').value){
      ssn = ssn.trim();
      if ((ssn.length === 10 || ssn.length === 12) &&ssn[ssn.length-5] != "-") {
        ssn = ssn.substring(0, ssn.length-4) + "-" + ssn.slice(ssn.length-4);
      }

      if (ssn.replace("-", "").trim().length === 10) {
        if (ssn.replace("-", "").trim()[0] < 3) {
          ssn = "20" + ssn;
        } else {
          ssn = "19" + ssn;
        }
      }
      if (ssn.slice(ssn.length-2).toUpperCase() === "TF") {
        ssn = ssn.substring(0, ssn.length-2) + "TF";
      }

      this.fellowApplicantForm.patchValue({
        ssn: ssn
      });
    }
    this.fellowApplicantExistsBySSN(ssn);
    this.fellowReadyToAdd()
  }
 /**
  * Function for automatically formatting the coordination of a fellow applicant if the user does not format correctly
  * @param coordinationNumber the coordination number to format and patch into the form
  */ 
  fellowCoordinationNumberFix(coordinationNumber) {
    coordinationNumber = coordinationNumber.trim();
    if ((coordinationNumber.length === 10 || coordinationNumber.length === 12) && coordinationNumber[coordinationNumber.length-5] != "-") {
      coordinationNumber = coordinationNumber.substring(0, coordinationNumber.length-4) + "-" + coordinationNumber.slice(coordinationNumber.length-4);
    }

    if (coordinationNumber.replace("-", "").trim().length === 10) {
      if (coordinationNumber.replace("-", "").trim()[0] < 3) {
        coordinationNumber = "20" + coordinationNumber;
      } else {
        coordinationNumber = "19" + coordinationNumber;
      }
    }
    this.fellowApplicantForm.patchValue({
      coordinationNumber: coordinationNumber
    });
    this.fellowApplicantExistsByCoordinationNumber(coordinationNumber);
    this.fellowReadyToAdd()

  }

  /**
   * Anchor
   * @param target id
   */
  public anchor(target): void {
    this.appService.scrollToTarget(target);
  }

  /**
     * Helper to update the number of notes displayed on top of the page.
     * Checks if the value from the notes component is a number and updates it.
     * If the value is not a number the amount of notes is taken from the notes array received in the initial request.
     * @param numOfNotes 
     */
   setNumOfNotes(numOfNotes: number){
    if(numOfNotes != null && !Number.isNaN(numOfNotes)){
        this.numOfNotes = numOfNotes;
    } else {
        this.numOfNotes = this.person.notes.length;
    }
  }

  getOwnerGroups(){
    this.service.getOwnerGroups().subscribe(
      data => this.setOwnerList(data), 
      error => this.showError(error)
    );
  }
  
  setOwnerList(data){
    this.groupList=data
    this.setupGroups(data)
  }

  setPersonGroup(event, selectedGroupId, group) {
    if(event && !this.personGroupList.find(memberId => memberId === selectedGroupId)){
      this.personGroupList.push(selectedGroupId);
    }
    else if(!event && this.personGroupList.find(memberId => memberId === selectedGroupId)){
      this.personGroupList.pop(selectedGroupId);
    } 
  }
  

  /**
   * helper to check the checkboxes for the persons groups when editing
   * @param groups groupList
   */
  setupGroups(groups: Array<any>) {
    if(this.person.groupsList != null){
      for(const group of groups){
        for(const personGroup of this.person.groupsList){
          if(group.id === personGroup.id){
            group.selected = true;
            this.setPersonGroup(true, group.id, group)
            break;
          }
        }
      }
    }
    this.groupList = groups
  }

  /**
   * Open OrgAssociation modal
   * @param selectedOrgAssociation 
   * @param selectedOrgAssociationIndex 
   */
  openPersonAssociation(selectedOrgAssociation: any, selectedOrgAssociationIndex: number) {      
    this.selectedOrgAssociation = selectedOrgAssociation;
    this.selectedOrgAssociationIndex = selectedOrgAssociationIndex; 
    this.ngxSmartModalService.getModal('personAssociation').open();
  } 

  /**
   * Set checked/unchecked if changes on RK shall be included
   */
  setIncludeRkOrgAssociation() {
    this.rkOrgAssociation.isChecked = !this.rkOrgAssociation.isChecked;    
  }

  /**
   * Update selected persons RK with selected OrgAssociation 
   */
  setRkOrgAssociationUpdate() {
    this.rkOrgAssociation.id = this.selectedOrgAssociation.id;
    this.rkOrgAssociation.update = true;
    this.rkOrgAssociation.delete = false;
    this.alertUpdatedAssociation = true;
  }

  /**
   * Delete selected OrgAssociation for all persons RK 
   */
  setRkOrgAssociationDelete() {
    this.deleteOrgAssociation(this.selectedOrgAssociationIndex);
    this.rkOrgAssociation.id = this.selectedOrgAssociation.id;
    this.rkOrgAssociation.update = false;
    this.rkOrgAssociation.delete = true;
  }
    
  /**
   * Helper to autocomplete a date with missing dividers '-'
   * @param date date string to patch
   * @param form the form to use
   * @param formControlName the formControlName to be patched with the date.
   */
  patchDate(date: string, form: string, formControlName: string) {
    if(date != null) {
        date = date.replace(/-/g,'');
    }
    if((date != null && date.trim() !== '') && 
      (formControlName != null && formControlName.trim() !== '') && date.length >= 8) {
        let yearPossition = 4;
        let monthPossition = 6;
        let dateDivader = '-'
        let patchedDate = date.substring(0,yearPossition) + dateDivader + date.substring(yearPossition, monthPossition) + dateDivader + date.substring(date.length-2, date.length)
        if(form === 'personForm') {
          this.personForm.patchValue({
              [formControlName]: patchedDate
          })
        } else if(form === 'fellowApplicantForm') {
          this.fellowApplicantForm.patchValue({
              [formControlName]: patchedDate
          })
        }
    }
    // if the form is a fellow applicant form check if the applicant is ready to add to the applicant list
    if(form === 'fellowApplicantForm') {
      this.fellowReadyToAdd()
    }
  }
  
  /**
   * Helper to check and format a date selected using a date picker
   * @param date moment object
   * @param form the form to use
   * @param formControlName the formControlName to be patched with the date.
   */
  checkSelectedDate(date, form: string, formControlName: string) {
    if(date != null) {
      let patchedDate = this.dateAdapter.format(date, 'YYYY-MM-DD');
      if(form === 'personForm') {
        this.personForm.patchValue({
            [formControlName]: patchedDate
        })
      } else if(form === 'fellowApplicantForm') {
        this.fellowApplicantForm.patchValue({
            [formControlName]: patchedDate
        })
      }
    }
    // if the form is a fellow applicant form check if the applicant is ready to add to the applicant list
    if(form === 'fellowApplicantForm') {
      this.fellowReadyToAdd()
    }
  }
}